/** Chip classes for the Plan 104 `result` values, shared by the timeline chips and the setup summary. */
export const RESULT_CLASS: Record<string, string> = {
  success: 'border border-status-success-border bg-status-success text-status-success-foreground',
  failure: 'border border-status-error-border bg-status-error text-status-error-foreground',
  timeout: 'border border-status-error-border bg-status-error text-status-error-foreground',
  retry: 'border border-status-warning-border bg-status-warning text-status-warning-foreground',
  cancelled: 'border border-status-warning-border bg-status-warning text-status-warning-foreground',
  skipped: 'border border-status-neutral-border bg-status-neutral text-status-neutral-foreground',
  start: 'border border-status-neutral-border bg-status-neutral text-status-neutral-foreground',
};

export const NEUTRAL_CLASS = RESULT_CLASS.start;
